import React from 'react';
import { Icon, TabsButton } from './styles';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import { ICON_SIZE } from '../../global/constants';

interface Props {
  title?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  disabled?: boolean;
  variant: number;
  size?: 'small' | 'medium';
  iconPosition?: 'start' | 'end' | 'none';
  iconName?: string;
  iconViewBox?: string;
  className?: string;
  isActive?: boolean;
  applyFullWidth?: boolean;
}

/**
 *
 * @param iconName - Name of the SVG icon to display
 * @param size - Button size ('small' or 'medium'), defaults to 'small'
 * @param variant - Visual variant number for styling
 * @param disabled - Whether the button is disabled
 * @param iconViewBox - ViewBox attribute for the SVG icon
 * @param iconPosition - Position of the icon ('start', 'end', or 'none')
 * @param title - Text to display in the button
 * @param className - Additional CSS class name
 * @param onClick - Click handler function
 * @param isActive - Whether the tab is currently active
 */
const Tabs: React.FC<Props> = ({
  iconName,
  size = 'small',
  variant,
  disabled,
  iconViewBox = '0 0 18 18',
  iconPosition,
  title,
  className,
  onClick,
  isActive,
  applyFullWidth
}) => {
  return (
    <>
      {/* Main button container with all styling props */}
      <TabsButton
        role='button'
        size={size}
        variant={variant}
        iconPosition={iconPosition}
        disabled={disabled}
        className={className}
        onClick={onClick}
        isActive={isActive}
        applyFullWidth={applyFullWidth}>
        {/* Render icon if iconName is provided */}
        {iconName && (
          <Icon variant={variant} disabled={disabled}>
            <SVGIcon
              name={iconName}
              height={ICON_SIZE.MD}
              width={ICON_SIZE.MD}
              fill='var(--text-secondary)'
              viewBox={iconViewBox}
            />
          </Icon>
        )}
        {/* Render title text (empty string if no title provided) */}
        {title || ''}
      </TabsButton>
    </>
  );
};

export default Tabs;
